import { isNil, isUndefined, maxBy, meanBy, minBy, range, round, sumBy } from 'lodash'
import moment from 'moment'

export default class DtoYearValues {
    constructor(day, days, minYear) {
        this.day = day
        const currentYear = moment().year()
        days.map((dayData, index) => {
            this[(minYear + index).toString()] = dayData
        })
        const dataWithValues = days.filter(data => !isUndefined(data.value) && data.value !== null)
        const min = minBy(dataWithValues, 'value')
        const mean = dataWithValues.length > 0 ? meanBy(dataWithValues, 'value') : null
        const max = maxBy(dataWithValues, 'value')
        const sum = dataWithValues.length > 0 ? sumBy(dataWithValues, 'value') : null

        this.min = { value: min ? min.value : null, color: 'orange' }
        this.mean = { value: !isNil(mean) ? round(mean, 2) : null, color: 'orange' }
        this.max = { value: max ? max.value : null, color: 'orange' }
        this.sum = { value: !isNil(sum) ? round(sum, 2) : null, color: 'orange' }
        this.headers = ['day'].concat(range(currentYear, minYear - 1).map(i => i.toString())).concat(['min', 'mean', 'max', 'sum'])
    }
}